export default {
  // 考勤
  attendance: {
    attendance: '考勤',
    attendanceMange: '考勤管理',
    attendanceNote: '急速打卡，輕松統計',
    clockRule: '打卡規則',
    attendanceMethod: '考勤方式',
    shiftMangae: '班次管理',
    workforceManage: '排班管理',
    otherSet: '其他設置',
    associatedApprovalForm: '關聯審批單',
    plugManage: '插件管理',
    attendanceStatistics: '考勤統計',
    addAddress: '添加地址',
    addWIFI: '添加WiFi',
    placeAttendance: '地點考勤',
    attendanceName: '考勤名稱',
    attendanceAdress: '考勤地址',
    attendanceNum: '考勤人數',
    attendanceType: '考勤類型',
    attendanceDate: '考勤日期',
    validRange: '有效範圍',
    m: '米',
    WIFIattendance: 'WiFi考勤',
    WIFIname: 'WiFi名稱',
    macAddress: 'MAC地址',
    setWIFI: '設置WiFi',
    wifiName_empty: '請輸入WiFi名稱',
    wifiName_error: '名稱盡量保持與考勤WiFi名稱壹致，避免員工產生誤解。',
    mac_empty: '請輸入MAC地址',
    mac_error: '請輸入正確的MAC地址',
    macTip: '不會填寫MAC地址？手機設置輕松完成。',
    tutorial: '點我看教程',
    attendanceWayDeleteTip:
      '提示：刪除後不可恢復，並且應用該考勤地點/WiFi的考勤組將不再能夠使用該地址/WiFi打卡',
    leastOneAddress: '請至少選定壹個地址',
    leastOneValidRange: '請至少選定壹個有效範圍',
    shiftsName: '班次名稱',
    maxLengthMust: '最多輸入6個字符，必填',
    attendanceTime: '考勤時間',
    commutingTimes: '上下班次數',
    workOnceDay: '1天1次上下班',
    workTwiceDay: '1天2次上下班',
    workthreeDay: '1天3次上下班',
    addShift: '添加班次',
    times: '次數',
    shift: '班次',
    clockTime: '打卡時間',
    clockTimeLimit: '打卡時間限制',
    forceClock: '強制打卡',
    first: '第1次',
    second: '第2次',
    third: '第3次',
    gotoWork: '上班',
    offDuty: '下班',
    nextDay: '次日',
    needClock: '需要打卡',
    noNeedClock: '不需要打卡',
    restTime: '休息時間',
    breakStart: '休息開始',
    breakEnd: '休息結束',
    break: '休息',
    time: '時間',
    select: '選擇',
    ruleEffectiveTime: '選擇規則生效時間',
    effectiveImmediatelyTip: '立即生效：今日考勤結果將按新規則重算',
    effectiveTomorrow: '明天生效',
    effectiveImmediately: '立即生效',
    anyTimeClock: '任何時間都能打卡',
    workBefore15: '上班前15分鐘內開始打卡',
    workBefore30: '上班前30分鐘內開始打卡',
    workBefore60: '上班前60分鐘內開始打卡',
    workBefore90: '上班前90分鐘內開始打卡',
    workBefore120: '上班前120分鐘內開始打卡',
    workBefore150: '上班前150分鐘內開始打卡',
    workBefore180: '上班前180分鐘內開始打卡',
    workAfter15: '下班後15分鐘內開始打卡',
    workAfter30: '下班後30分鐘內開始打卡',
    workAfter60: '下班後60分鐘內開始打卡',
    workAfter90: '下班後90分鐘內開始打卡',
    workAfter120: '下班後120分鐘內開始打卡',
    workAfter150: '下班後150分鐘內開始打卡',
    workAfter180: '下班後180分鐘內開始打卡',
    shiftsName_empty: '班次名稱不能為空',
    timeSequence_error: '請按時間順序設置時間點',
    addAttendanceGroup: '添加考勤組',
    fixedShiftSystem: '固定班制',
    schedulingSystem: '排班制',
    freeWorkingHours: '自由工時',
    weekly: '每周',
    clockAtAnyTim: '不設置班次，隨時打卡',

    scheduling: '排班',
    stepOne: '第壹步：下載排班列表',
    stepTwo: '第二步：導入排班列表',
    attendanceScheduling: '考勤排班',
    schedulingPeriod: '排班周期',
    adjusted: '已調整',
    item: '項',
    recover: '恢復',
    addRosterPeriod: '添加排班周期',
    cycleName: '周期名稱',
    cycleNameLength: '請輸入周期名稱，限制6個字以內',
    cucleDay: '周期天數',
    cycle: '周期',
    shiftTime: '班次時間',
    di: '第',
    restDay: '當天休息',
    hugh: '休',
    discardSave: '是否確定放棄保存',
    dataNotSaved: '當月排班數據尚未保存',
    attendanceManage: '考勤管理員',
    saveSet: '保存設置',
    clockReminder: '打卡提醒',
    wordTimeBefore: '上班時間前',
    remindWorkCard: '分鐘，提醒員工打上班卡。',
    afterHours: '下班時間後',
    remindClockOut: '分鐘，提醒員工打下班卡。',
    listSet: '榜單設置',
    allGroupTogether: '所有考勤組都統計在壹起',
    attendanceGroupstatistics: '按考勤組分開統計',
    earlyArrivalList: '早到榜',
    listStatistics: '榜單統計方式',

    statisticsEveryDayBefore: '統計每天前',
    punchCardSituation: '名的打卡情況。',
    diligenceList: '勤勉榜',
    statisticsEveryMonthBefore: '統計每個月前',
    lateList: '遲到榜',
    lateStatisticsMethod: '遲到統計方式',
    lateness_error: '按遲到次數排序。遲到次數越多排序越靠前，次數相同則按遲到時長排序',
    lateHours_error: '按遲到時長排序。遲到時長越長排序越靠前，遲到時長相同則按遲到次數排序。',
    lateArrivalAndLateDeparture: '晚到晚走',
    firstDayLeaveLate: '第壹天下班後晚走',
    nextDayLeaveLate: '第二天上班後晚到',
    humanizedShift: '人性化班次',
    everyMonthLate: '每個月累計允許遲到',
    lateOneTimeAllowed: '單次遲到允許遲到',
    lateOneTimeAllowed2: '累計允許遲到',
    singleLate: '單次遲到超過',
    singleLeaveEarly: '單次早退超過',
    absenteeismRules: '曠工規則',
    recordedAbsenteeism: '分鐘，記為曠工。',
    absenteeismRulesTip: '默認曠工規則：上下班都未打卡記為曠工',
    error1: '只能輸入大於等於0的整數',
    error2: '只能輸入大於0的整數',
    late: '遲到',
    lateTime: '遲到時間',
    leaveEarly: '早退',
    lateTime_error: '允許遲到時間不得大於曠工規則設定時間',
    absenteeismRules_error: '曠工規則設定時間不得小於允許遲到時間',
    lateDepartureTime: '晚走時間',
    workBefore: '上班前',
    goOffWorkBefore: '下班前',
    ci: '次',
    articlePage: '條/頁',
    numberShifts: '班人數',
    scheduleByDay: '按天排班',
    scheduleByCycle: '按周期排班',
    modifyshift: '修改該員工當天班次',
    thisDayToEndOfMonth: '從該天開始周期排班至月底',
    name: '姓名',
    statistics: '統計人數',
    modifyTips: '只能修改當前月份及上個月的排班',
    attendanceGroup: '考勤組',
    attendanceGroupName: '考勤組名稱',
    attendanceGroupNameLength10: '請輸入考勤名稱，限制10個字以內',
    attendanceName_empty: '考勤名稱不能為空',
    attendanceOfficer: '考勤人員',
    attendanceOfficer_empty: '考勤人員不能為空',
    noAttendanceRequired: '無需考勤人員',
    sameTime: '每天考勤時間壹樣',
    sameTimeTip: '適用於：IT、金融、文化傳媒、政府/事業單位、教育培訓等行業',
    weekdays: '工作日',
    legalHolidays: '法定節假日自動排休',
    customAttendanceTime: '自定義設置考勤時間',
    customAttendanceTimeTip: '適用於：餐飲、制造、物流貿易、客戶服務、醫院等行業',
    shiftTip: '保存打卡規則之後，請到“排班管理”裏面給當前規則裏面的成員設置排班',
    noShiftTip: '適用於：班次沒有規律，裝修，家政，物流等計算工作時長的行業',
    specialClock: '特殊打卡',
    mustPunchDate: '必須打卡日期',
    date: '日期',
    editShift: '編輯班次',
    noClockDate: '不用打卡日期',
    setWeekdays: '設置工作日',
    attendanceStartTime: '考勤開始時間',
    attendanceStartTimeTip: '每天幾點開始新壹天的考勤',
    attendanceTypeTip: '以下方式滿足壹項，考勤組成員即可完成考勤',
    attendanceTypeTip1: '根據辦公地點考勤（可添加多個考勤地點）',
    addAttendanceAddress: '添加考勤地址',
    attendanceTypeTip2: '根據WiFi考勤（精確定位到辦公室內，可添加多個辦公WiFi）',
    addWIFIAddress: '添加WiFi地址',
    allowClock: '允許外勤打卡',
    punchClock: '人臉識別打卡',
    addData: '添加日期',
    multipleShiftTypes: '可選擇多種班次類型',
    setUpShifts: '設置班次',
    selectShift: '選擇班次',
    pleasSelectShift: '請選擇班次',
    attendanceWifiAddress_error: '根據辦公地點考勤與根據WiFi考勤必須設置壹項',
    dateRepeated: '日期已重復',
    data_empty: '日期不能為空',
    redPacket: '紅包',
    redPacketNote: '考勤成功後有紅包獎勵，激勵員工',
    addRule: '添加規則',
    rewardContent: '獎勵內容',
    numberAwards: '獎勵數量',
    rewardAmount: '獎勵金額',
    shake: '搖壹搖',
    faceRecognition: '人臉識別',
    faceRecognition2: '精準識別人臉，拍照完成考勤打卡',
    fastPunch: '極速打卡',
    fastPunch2: '只需要在考勤時間段內打開app，系統就會自動幫您完成打卡',
    connectAttendanceMachine: '連接考勤機',
    connectAttendanceMachine2: '打通線上線下雙平臺，考勤數據全匯總（僅支持指定考勤機）',
    redPacketSet: '紅包設置',
    redPacketSetTip1: '早到榜是每天更新的榜單，統計的是每天最早來機構的員工。',
    redPacketSetTip2: '紅包獎勵為即時發放，只要打卡在獲獎範圍，就會發送紅包。',
    topOfList: '排行榜前',
    ranking: '名',
    distributionMethod: '分配方式',
    average: '均分',
    random: '隨機',
    custom: '自定義',
    allAttendanceRecords: '原始打卡記錄',
    dailySummary: '每日匯總',
    monthlySummary: '每月匯總',
    exceptionRecord: '異常記錄',
    fieldName: '字段名稱',
    clockAddress: '打卡地址',
    clockResults: '打卡結果',
    week: '星期',
    remark: '備註',
    clockEquipment: '打卡設備',
    fieldPersonnel: '外勤',
    month: '月份',
    attendanceDays: '出勤天數',
    daysOff: '休息天數',
    workingHours: '工作時長',
    lateTimes: '遲到次數',
    lateRecord: '遲到記錄',
    lengthOfBeingLate: '遲到時長',
    earlyLeaveTimes: '早退次數',
    earlyLeaveRecord: '早退記錄',
    lengthOfEarlyLeave: '早退時長',
    cardMissingTimes: '上班缺卡次數',
    cardMissingTimes2: '打卡時間：上班缺卡',
    cardMissingRecord: '缺卡記錄',
    numberCardsMissingFromWork: '下班缺卡次數',
    numberCardsMissingFromWork2: '打卡時間：下班缺卡',
    absenteeismDays: '曠工天數',
    absenteeismRecord: '曠工記錄',
    attendanceRequiredDays: '應出勤天數',
    lateAbsenteeism: '遲到曠工',
    earlyLeaveAbsenteeism: '早退曠工',
    clockTimeAbsenteeism: '打卡時間：曠工',
    leave: '請假',
    overtime: '加班',

    yymmdd: 'yyyy年MM月dd日',
    yymmddhhmm: 'yyyy年MM月dd日 HH:mm',
    editRecord: '修改記錄',
    normal: '正常',
    modifyReason: '修改原因',
    minute_empty: '分鐘不能為空',
    modifyTip1: '將打卡結果“',
    modifyTip2: '”修改為“',
    modifyTip3: '修改理由',
    arrive: '到',
    goout: '外出',
    changeFlight: '更改班次',
    evection: '出差',
    reissue: '補卡',

    addPersonnel: '添加人員',
    synchronousPersonnel: '同步人員',
    serialNumber: '序號',
    machineNumber: '考勤機中對應人員工號',
    attendanceMachine: '考勤機',
    attendanceMachineManufacturer: '考勤機廠商',
    attendanceMachineName: '考勤機名稱',
    attendanceMachineName_error: '考勤機名稱不能為空',
    attendanceMachineSN: '考勤機SN',
    timingTime: '定時時間',
    timingTime_error: '定時時間不能為空',
    synchronousTime_error: '同步時間不能為空',
    attendanceMachineSN_error: '考勤機SN不能為空',
    timeInterval_error: '時間間隔不能為空',
    attendanceMachineTip: '考勤機-設備信息-序列號',
    attendanceMachineDeleteTip: '確認要刪除該考勤機嗎？',
    off: '斷開',
    sameAttendanceGroup: '僅針對同壹考勤組排班人員進行更換',
    signatureCardType: '簽卡類型',
    cardReplacementTime: '補卡時間',
    overtimeType: '加班類型',
    leaveType: '請假類型',
    why: '原因',
    selected: '已選擇',
    arecord: '條記錄',
    importedTip: '請按照數據模板的格式準備要導入的數據。',
    notes: '註意事項',
    notes1: '1、模板中的表頭名稱不可更改，表頭行不能刪除；',
    notes2: '2、導入格式為xlsx，最多只允許上傳10000條，文件大小不超過20M；',
    notes3: '3、姓名、考勤組、考勤日期、考勤時間、打卡時間為必填；',
    notes4: '4、若姓名相同，請必須填寫工號匹配人員考勤；',
    notes5: '5、導入的數據僅針對缺卡狀態數據，未缺卡狀態不可導入更新；',
    importTemplate: '點此下載數據導入模板',
    addFile: '添加文件',
    startImporting: '開始導入',
    synchronizingData: '同步歷史數據',
    startSync: '開始同步',
    laterData: '之後的數據',
    realTimeSync: '實時同步',
    timing: '定時',
    syncBetween: '間隔同步',
    attendanceMachineTip2: '請配置需要獲取哪些考勤機數據，以及配置每臺考勤機需要同步人員。',
    every: '每隔',
    getAttendanceData: '分鐘獲取壹次考勤數據',
    effectiveStartTime: '有效開始時間',
    effectiveEndTime: '有效結束時間',
    startAndEndTime_error: '開始時間不能大於等於結束時間',
    overtimeTime_empty: '加班時長不能為空',
    overtimeTime_error: '加班時長格式錯誤',
    yuanyin_error: '原因不能為空',
    fileFormatError: '文件格式錯誤',
    onelateminute: '單次遲到分鐘',
    cumulativelateminute: '累計遲到分鐘',
    autoMatchTip: '未排班時，智能化匹配班次，也可手動修改班次',
    correctedstate: '修正狀態',
    cardreplacementrule: '補卡規則',
    annualleaverule: '年假規則',
    overtimerule: '加班規則',
    lackofapprovalcard: '審批通過後，該時間段內的考勤“缺卡”狀態將會被自動修正為“正常”。',
    afterapprovalmonthlystatistics: '審批通過後，該審批單會納入考勤月統計當中',
    cardreplacementtimefield: '補卡時間對應字段',
    starttimecorrespondstotime: '開始時間對應時間',
    endtimecorrespondstotime: '結束時間對應時間',
    fieldcorrespondingtolength: '時長對應字段',
    itemTip1: '該項用於年假和調休假余額扣除所使用',
    numberofcardrepayments: '限制補卡次數：每月可提交',
    secondaryreplacementcard: '次補卡',
    calculatedfromnaturalmonth: '（按自自然月計算）',
    limitedreplacementtime: '限制補卡時間：可申請過去',
    replacementcardwithindays: '天內的補卡',
    fillindaysTip: '（填寫0天，則只能發起當天的補卡）',
    calculationofapprovaltime: '按審批單時長計算',
    calculatedbyclockingtime: '按打卡時長計算',
    overtimeTip1: '分鐘之後，開始計算為加班',
    overtimeTip2: '當天加班少於',
    overtimeTip3: '分鐘，不計算為加班',
    missingcard: '缺卡',
    leaveclearance: '銷假',
    replacementcardnumber_error: '限制補卡次數格式錯誤',
    replacementcardtime_error: '限制補卡時間格式錯誤',
    pleaseenterintegers0720: '請輸入0-720的整數',
    associatedapprovalform_empty: '請選擇關聯審批單',
    fixstatus_empty: '請選擇修正狀態',
    typeofleave_empty: '請選擇請假類型',
    overtimetype_empty: '請選擇加班類型',
    thetimecorrespondingtothestarttime_empty: '請選擇開始時間對應時間',
    thetimecorrespondingtotheendtime_empty: '請選擇結束時間對應時間',
    thefieldcorrespondingtoduration_empty: '請選擇時長對應字段',
    thefieldcorrespondingtocardreplacementtime_empty: '請選擇補卡時間對應字段',
    addattendancemachine: '添加考勤機',
    enterattendancemachine: '進入考勤機',
    pushTip: 'PUSH（支持B/S架構的考勤機）',
    offline: '脫機',
    attendancedockingaddress: '考勤對接地址',
    modeofcommunication: '通訊方式',
    attendancemachine_serialnumber: '考勤機-設備信息-序列號',
    ipaddress: 'IP地址',
    port: '端口',
    communicationpassword: '通訊密碼',
    fetchtime: '獲取數據時間',
    centralcontrol: '中控',
    ipcannotbeempty: 'IP不能為空',
    ipformaterror: 'IP格式錯誤',
    portcannotbeempty: '端口不能為空',
    communicationpasswordcannotbeempty: '通訊密碼不能為空',
    syncmode: '同步模式',
    interfacetype: '接口類型',
    communicationmode: '通訊模式',
    attendancemachinehasbeenrepeated: '考勤機已重復',
    punchinaccordingtoattendancemachine: '根據考勤機打卡',
    connectattendancemachinesettings: '(請到插件管理-->連接考勤機中設置)',
    atleastoneattendancemethod: '請至少選擇壹項考勤方式',
    pleaseaddattendanceaddress: '請添加考勤地址',
    returnlist: '返回列表',
    annualleavesetting: '年假設置',
    switchoffsetting: '調休設置',
    holidaybalance: '假期余額',
    setemployeeannualleavebalance: '設置員工年假余額',
    annualleave: '年假',
    balancesendingmode: '余額發送方式',
    releasedate: '發放日期',
    correspondstotheentrydatein: '對應【成員管理】中的入職日期',
    quotaallocationrules: '配額配置規則',
    perpersonperyear: '每人每年發放',
    fullage: '司齡滿',
    yeardiscontent: '年，不滿',
    annualsabbatical: '年的，可休假',
    yearannualleaveallowed: '年，可休年假',
    expirationdate: '有效期',
    yearfromthedateofissue: '自發放日期起1周年',
    allowedextensionofvalidityperiod: '允許延長有效期',
    afterexpirybalanceretained: '超過有效期後，余額保留',
    setasrestshift: '設置計為調休',
    leaveofabsence: '請假調休',
    overtimeshiftonweekdays: '工作日加班調休',
    overtimeshiftonrestday: '休息日加班調休',
    workingovertimeonholidays: '節假日加班調休',
    press1: '按 1:',
    afterhowmanydaysofovertime: '加班多少天後作廢',
    voidafterday: '天後作廢',
    howmanydaysexpireaftertoday: '今日設置後，多少天過期',
    entrydate: '入職日期',
    record: '記錄',
    editannualleave: '編輯年假',
    editleave: '編輯調休假',
    modifybalance: '修改余額',
    issuedautomaticallyonceayear: '每年自動發放1次',
    january1steachyear: '每年1月1日',
    annualemployeeentryday: '每年員工入職日',
    fixedquota: '固定額度',
    byseniority: '按司齡（本機構工齡為單位）',
    increase: '增加',
    reduce: '減少',
    annualleavecannotbeempty: '年假不能為空',
    fixedlimitformaterror: '固定額度格式錯誤',
    quotaruleformaterror: '配額規則格式錯誤',
    leaveleavecannotbeempty: '請假調休不能為空',
    atleastonetypeofovertime: '請至少選擇壹個加班類型',
    wrongformatofworkingovertimeshiftrate: '工作日加班調休倍率格式錯誤',
    wrongformatofovertimeshiftratioonrestday: '休息日加班調休倍率格式錯誤',
    wrongformatofovertimeworkingrateonholidays: '節假日加班調休倍率格式錯誤',
    invaliddayscannotbeempty: '作廢天數不能為空',
    invalidnumberofdaysformattedincorrectly: '作廢天數格式錯誤',
    calculatedastimeoff: '計為調休時長',
    transferleave: '調休假',
    absenteeism: '曠工',
    verify: '驗證',
    sameattendancegroup_error: '請勾選同壹個考勤組人員',
    length: '時長',
    originalshift: '原班次',
    timeperiod: '時間段',
    nodataavailable: '沒有可操作的數據',
    effectiveRange: '打卡有效範圍',
    ruleContent: '規則內容',
    // 20210305
    importtemplate: '考勤導入模板',
    test: '123'
  }
}
